import './components/DynamicForm'
import './components/FAQ'
import './components/Lightbox'
import './components/ImageSlider'
import './components/Shops'
import './components/CookieBar'
import Carousel from './components/Carousel'

addEventListener('DOMContentLoaded', () => {
	Carousel.initializeAll()
	initializeHamburgerMenu()
})

window.addEventListener('scroll', function(){
	let header = document.getElementsByTagName('header')[0]
	let scrolled = window.scrollY > header.offsetHeight == true;

	document.body.classList.toggle('scrolled', scrolled);
})

function initializeHamburgerMenu() {
	const header = document.querySelector('header')

	const hamburger = document.getElementById('hamburger')
	hamburger?.addEventListener('click', () => {
		document.body.classList.toggle('menu-open')
	})

	// Allow double tapping for mobile users.
	const parentItems = header.querySelectorAll('li.has-children > a, #languages div.dropdown')
	for (let a = 0; a < parentItems.length; a++) {
		parentItems[a].addEventListener('click', function (event) {
			if (event.pointerType === 'touch') {
				if (!this.active) {
					event.preventDefault()
				}
				this.active = true
			}
		})

		parentItems[a].addEventListener('mouseleave', function (event) {
			this.active = false
		})
	}
}